import {directive} from 'vue-clickaway'
import syncConentHeight from './directives/sync-content-height'
/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install (Vue) {

    Vue.directive('click-outside', directive)


    const bindFnc = (el, binding) => {
      const disabled = binding.value
      const tags = ["input", "button", "textarea", "select"]
      el.style.opacity = disabled ? '0.5': '1'
      tags.forEach(tagName => {
        const nodes = el.getElementsByTagName(tagName)
        for (const node of nodes) {
          node.disabled = disabled
        }
      });
    }
    Vue.directive('disabled-fieldset', {
      // When all the children of the parent component have been updated
      inserted: bindFnc,  
      update: bindFnc
    })    


    Vue.directive('sync-height', syncConentHeight )

    Vue.directive('focus', {
      // When the bound element is inserted into the DOM...
      inserted: function (el) {
        // Focus the element
        el.focus()
      }
    })    

  }
}

export default GlobalDirectives
